import React from "react";
import { Button } from '@kdcloudjs/kdesign'
import eventBus from '../../../../../../../util/eventBus'

const btnStyle = { marginLeft: '10px' }

function BtnBar(props) {
    console.log("-----btn app-----", props);

    const {
        myInvoke, btnParams, model, editStatus, updateState, isOpenPersonalStyle,
        currentNodeIsNull, direction, refreshPage } = props

    const { invoke } = model

    const { hasCardEditPerm = 0, hasChartExportPerm = 0 } = btnParams

    function mainClick() {
        myInvoke("orgChartPermQuery", {}, "orgChartPermQuery")
            .then(data => {
                console.log("orgChartPermQuery mainClick", data);

                updateState("btnParams", {
                    hasChartExportPerm: data.hasChartExportPerm,
                    hasCardEditPerm: data.hasCardEditPerm,
                })

                if (data.hasChartExportPerm === 1) {
                    invoke("dataRouteKey", {
                        routeTarget: 1,
                        data: JSON.stringify({
                            eventName: "export",
                            value: "0"
                        })
                    })
                }
            })


    }

    function itemClick(args) {
        myInvoke("orgChartPermQuery", {}, "orgChartPermQuery")
            .then(data => {
                console.log("orgChartPermQuery itemClick", data);

                updateState("btnParams", {
                    hasChartExportPerm: data.hasChartExportPerm,
                    hasCardEditPerm: data.hasCardEditPerm,
                })

                if (data.hasChartExportPerm === 1) {
                    invoke("dataRouteKey", {
                        routeTarget: 1,
                        data: JSON.stringify({
                            eventName: "export",
                            value: args.value   //1ppt 2pdf
                        })
                    })
                }
            })
    }

    function handleEdit() {
        myInvoke("orgChartPermQuery", {}, "orgChartPermQuery")
            .then(data => {
                console.log("orgChartPermQuery handleEdit", data);

                updateState("btnParams", {
                    hasChartExportPerm: data.hasChartExportPerm,
                    hasCardEditPerm: data.hasCardEditPerm,
                })

                if (data.hasCardEditPerm === 1) {
                    updateState("editStatus", true)
                    invoke("dataRouteKey", {
                        routeTarget: 1,
                        data: JSON.stringify({
                            eventName: "edit"
                        })
                    })
                }
            })
    }

    function handleRefresh() {
        refreshPage()
    }

    function handleExit() {
        invoke("closeOrgChart")
    }

    return (
        <div className="org-btn-bar">
            {(!!hasCardEditPerm && !editStatus) && (<Button type="primary" disabled={currentNodeIsNull} style={btnStyle} onClick={handleEdit} >编辑</Button>)}
            {!!hasChartExportPerm && !editStatus && (<Button.Dropdown
                disabled={currentNodeIsNull}
                style={btnStyle}
                popperStyle={{ zIndex: 1000 }}
                overlay={
                    (!!isOpenPersonalStyle || direction !== "1") ?
                        [
                            { value: '2', label: '导出PDF' },
                        ] :
                        [
                            { value: '1', label: '导出PPT' },
                            { value: '2', label: '导出PDF' },
                        ]
                }
                type="similar"
                onClick={mainClick}
                onItemClick={itemClick}>
                导出PNG
            </Button.Dropdown>)}
            {!editStatus && (
                <Button type="primary" style={btnStyle} onClick={handleRefresh}>刷新</Button>
            )}
            <Button type="primary" style={btnStyle} onClick={handleExit}>退出</Button>
        </div>
    )
}

export default BtnBar